import { render, staticRenderFns } from "./AlertPopupComponent.vue?vue&type=template&id=2e2003dd&"
import script from "./AlertPopupComponent.vue?vue&type=script&lang=js&"
export * from "./AlertPopupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports